export default [
  {
    path: '/config-emitente',
    name: 'config-emitente',
    component: () => import(/* webpackChunkName: "config-emitente" */ './Config-emitente')
  }
]
